import React from 'react'
import ApprovalAttendanceRequest from './ApprovalAttendanceRequest'
import { Box, Typography } from '@mui/material'

const AttendanceApproval = () => {

    const ViewComponent = ApprovalAttendanceRequest

    if (ViewComponent) {
        return <ApprovalAttendanceRequest />
    }

    return (
        <Box sx={{ height: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
            <Typography color="text.secondary">
                {'Incorrect link. Please check the link and try again.'}
            </Typography>
        </Box>
    )
}

export default AttendanceApproval
